/**
 * Love Store Paris — Remplace les icônes clip-art des policies par des SVG LSP
 */
(function () {
  var root = document.querySelector('.lsp-page-legal');
  var body = document.querySelector('.lsp-page-legal__body');
  if (!root || !body) return;

  var policyPath = (root.getAttribute('data-lsp-policy-path') || window.location.pathname || '').toLowerCase();
  var isRefundPolicy = policyPath.indexOf('refund-policy') !== -1 || policyPath.indexOf('remboursement') !== -1;

  var ICONS = {
    return:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>',
    bolt:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    ban:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>',
    shield:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
    message:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    default:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
  };

  /* Politique remboursement — mapping explicite des 4 blocs */
  var REFUND_SECTIONS = [
    { pattern: /politique de retour|retour et de remboursement|remboursement/i, type: 'return' },
    { pattern: /livraisons express|30 min|1h banlieue|livraison express/i, type: 'bolt' },
    { pattern: /annulation|modification|retour ou remboursement n.?est pas possible|aucune annulation/i, type: 'ban' },
    { pattern: /produits non retournables|hygiène|sécurité|non retournable/i, type: 'shield' },
  ];

  var REFUND_ICON_ORDER = ['return', 'bolt', 'ban', 'shield'];

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isNodeAfter(ref, node) {
    if (!ref || !node) return false;
    return !!(ref.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function findContactHeading() {
    var headings = body.querySelectorAll('h2, h3, h4');
    for (var i = 0; i < headings.length; i++) {
      if (/contact service client|service client|nous contacter/i.test(normalizeText(headings[i].textContent))) {
        return headings[i];
      }
    }
    return null;
  }

  function isContactSectionImage(img, anchor, contactHeading) {
    if (!contactHeading) return false;
    if (contactHeading.contains(img)) return true;
    if (anchor && anchor.el === contactHeading) return true;
    if (anchor && isNodeAfter(contactHeading, anchor.el)) return true;
    if (isNodeAfter(contactHeading, img)) return true;

    var container = findImageContainer(img);
    if (container && isNodeAfter(contactHeading, container)) return true;

    if (anchor && anchor.type === 'heading' && anchor.el === contactHeading) return true;

    return false;
  }

  function removeLegacyImage(img) {
    var container = findImageContainer(img);
    if (container && isImageOnlyNode(container) && container !== body) {
      container.remove();
      return;
    }
    img.remove();
  }

  function flattenContactCallouts(contactRoot) {
    contactRoot.querySelectorAll('.lsp-page-legal__callout').forEach(function (callout) {
      var content = callout.querySelector('.lsp-page-legal__callout-content');
      var p = document.createElement('p');
      p.innerHTML = content ? content.innerHTML : callout.innerHTML;
      callout.replaceWith(p);
    });

    contactRoot.querySelectorAll('.lsp-page-legal__icon').forEach(function (icon) {
      icon.remove();
    });

    contactRoot.querySelectorAll('h2, h3, h4').forEach(function (heading) {
      heading.classList.remove('lsp-page-legal__heading-with-icon');
    });
  }

  function formatContactSection(contactHeading) {
    if (!contactHeading || contactHeading.closest('.lsp-page-legal__contact')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'lsp-page-legal__contact';

    contactHeading.parentNode.insertBefore(wrapper, contactHeading);
    wrapper.appendChild(contactHeading);

    var next = wrapper.nextElementSibling;
    while (next && !/^H[2-4]$/.test(next.tagName)) {
      var toMove = next;
      next = next.nextElementSibling;
      wrapper.appendChild(toMove);
    }

    flattenContactCallouts(wrapper);
  }

  function getContextText(img, anchor) {
    var parts = [
      img.getAttribute('alt') || '',
      img.getAttribute('src') || '',
      img.getAttribute('title') || '',
    ];

    if (anchor && anchor.el) {
      parts.push(anchor.el.textContent || '');
    }

    var container = img.parentElement;
    if (container) {
      parts.push(container.textContent || '');
      if (container.nextElementSibling) {
        parts.push(container.nextElementSibling.textContent || '');
      }
      if (container.previousElementSibling) {
        parts.push(container.previousElementSibling.textContent || '');
      }
    }

    return parts.join(' ').toLowerCase();
  }

  function guessIconType(img, anchor, index) {
    var context = getContextText(img, anchor);

    if (/contact service client|service client|lovestoreparis@gmail|9 rue de lyon|whatsapp/i.test(context)) {
      return null;
    }

    if (isRefundPolicy) {
      for (var i = 0; i < REFUND_SECTIONS.length; i++) {
        if (REFUND_SECTIONS[i].pattern.test(context)) {
          return REFUND_SECTIONS[i].type;
        }
      }
      if (typeof index === 'number' && index < REFUND_ICON_ORDER.length) {
        return REFUND_ICON_ORDER[index];
      }
    }

    if (/retour|rembours|refresh|return|échange|refund/.test(context)) return 'return';
    if (/express|livraison|lightning|éclair|bolt|30 min|1h|flash/.test(context)) return 'bolt';
    if (/annulation|modification|impossible|stop|interdit|aucune/.test(context)) return 'ban';
    if (/hygiène|retournable|sécurité|prohibition|shield|produit/.test(context)) return 'shield';

    return 'default';
  }

  function createIcon(type) {
    var span = document.createElement('span');
    span.className = 'lsp-page-legal__icon lsp-page-legal__icon--' + type;
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = ICONS[type] || ICONS.default;
    return span;
  }

  function isImageOnlyNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName === 'IMG') return true;
    if (!/^(P|DIV|SPAN|FIGURE|A|LI)$/i.test(node.tagName)) return false;

    var clone = node.cloneNode(true);
    clone.querySelectorAll('br, wbr').forEach(function (el) {
      el.remove();
    });
    var text = normalizeText(clone.textContent).replace(/\u00a0/g, '');
    return !!clone.querySelector('img') && text === '';
  }

  function findImageContainer(img) {
    var node = img.parentElement;
    while (node && node !== body) {
      if (isImageOnlyNode(node)) return node;
      if (/^H[2-4]$/.test(node.tagName)) return null;
      node = node.parentElement;
    }
    return img.parentElement;
  }

  function findAnchor(img) {
    var heading = img.closest('h2, h3, h4');
    if (heading) return { type: 'heading', el: heading };

    var container = findImageContainer(img);
    if (!container) return null;

    var sibling = container.nextElementSibling;
    while (sibling) {
      if (/^H[2-4]$/.test(sibling.tagName)) {
        return { type: 'heading', el: sibling, removeContainer: container };
      }

      if (sibling.tagName === 'P' && normalizeText(sibling.textContent).length > 0) {
        var nestedHeading = sibling.querySelector('h2, h3, h4');
        if (nestedHeading) {
          return { type: 'heading', el: nestedHeading, removeContainer: container };
        }
        return { type: 'callout', el: sibling, removeContainer: container };
      }

      var blockHeading = sibling.querySelector('h2, h3, h4');
      if (blockHeading) {
        return { type: 'heading', el: blockHeading, removeContainer: container };
      }

      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  function attachIconToHeading(heading, icon) {
    if (heading.querySelector('.lsp-page-legal__icon')) return;
    heading.classList.add('lsp-page-legal__heading-with-icon');
    heading.insertBefore(icon, heading.firstChild);
  }

  function attachIconToCallout(paragraph, icon) {
    if (paragraph.closest('.lsp-page-legal__callout')) return;

    var callout = document.createElement('div');
    callout.className = 'lsp-page-legal__callout';
    callout.appendChild(icon);

    var content = document.createElement('div');
    content.className = 'lsp-page-legal__callout-content';
    while (paragraph.firstChild) {
      content.appendChild(paragraph.firstChild);
    }
    callout.appendChild(content);
    paragraph.replaceWith(callout);
  }

  var contactHeading = findContactHeading();
  var images = Array.prototype.slice.call(body.querySelectorAll('img'));

  images.forEach(function (img, index) {
    var anchor = findAnchor(img);

    if (isContactSectionImage(img, anchor, contactHeading)) {
      removeLegacyImage(img);
      return;
    }

    var type = guessIconType(img, anchor, index);
    if (!type) {
      removeLegacyImage(img);
      return;
    }

    var icon = createIcon(type);

    if (anchor) {
      if (anchor.type === 'heading') {
        attachIconToHeading(anchor.el, icon);
        img.remove();
      } else {
        attachIconToCallout(anchor.el, icon);
        if (anchor.removeContainer) anchor.removeContainer.remove();
      }
      return;
    }

    img.replaceWith(icon);
  });

  formatContactSection(contactHeading);

  root.setAttribute('data-lsp-legal-icons-ready', '');
})();
